import { getHeader } from "@libs/authorization/projects/wf/config_translate";
import env from "@libs/util/environment";

export default {
  continue: "https://wf.my.com/en/?mgmode=1",
  auth: 0,
  client_id: "wf.my.com",
  failure: "https://pc.warface.com/?error",
  lang: env.getPosixLocale(),
  no_headline: 1,
  no_header: 1,
  signup_subscribe: 1,
  signup_continue: "https://pc.warface.com/dynamic/auth/?confirm_reg=true",
  signup_repeat: 0,
  signup_captcha: "recaptcha",
  gc_id: "13.2000076",
  gc_download_url: "https://static.gc.my.com/WarfaceMycomLoader.exe",
  gc_download_heading: getHeader(),
  gc_download_pic_path: "https://pc.warface.com/static/wf.my.com/img/main/content/download",
  with_tw: 1,
  with_fb: 1,
  verification_continue: "https://account.my.games/email_verify/?ok=1",
  show_subscribe: 0,
  subscribe_checked: 0,
  signup_tou: 1,
  signup_method: "email,phone",
  signup_birthday: 0,
  signup_nickname: 0,
  signup_promo: "",
  verification_letter_id: 2724,
  gc_detect_timeout: 3,
  hide_tabs: 0,
  hide_i_have: 0,
  terms_accepted: 0,
  client_name: "",
  signup_social: "mailru,eg,fb,vk,g,ok,twitch,tw,ps,xbox,steam",
  signup_soc_ps: 1,
  signup_soc_xbox: 1,
  signup_soc_steam: 1,
};
